export const actions = {
    GET_CONFIGURATION: 'GET_CONFIGURATION',
    GET_CONFIGURATION_SUCCESS: 'GET_CONFIGURATION_SUCCESS',
    GET_CONFIGURATION_FAILED: 'GET_CONFIGURATION_FAILED',
}

export const getConfiguration = country => ({
    type: actions.GET_CONFIGURATION,
    country,
})

export const getConfigurationSuccess = configuration => ({
    type: actions.GET_CONFIGURATION_SUCCESS,
    payload: configuration,
})

export const getConfigurationFailed = error => ({
    type: actions.GET_CONFIGURATION_FAILED,
    payload: error,
})
